import { Paper } from "@material-ui/core";
import { MasterButton, Modal, SearchInput } from "App/Component/ui";
import { isNull } from "App/utils/helpers";
import React, { useContext, useEffect, useState } from "react";
import { OrganisasiCtx } from "../context/context";
import { STYLE_MASTER_SATU_SEHAT_ORGANISASI } from "./helpers";
import useReloadTableLokasi from "./hooks/useReloadTableLokasi";
import OrganisasiLokasiTable from "./OrganisasiLokasiTable";

const OrganisasiLokasiPreview = ({ setShowModal, lokasi, setLokasi }) => {
	const classes = STYLE_MASTER_SATU_SEHAT_ORGANISASI();

	const [children, setChildren] = useState([]);
	const [infoChildren, setInfoChildren] = useState("");

	const { state } = useContext(OrganisasiCtx);
	const rows = state.lokasi.body;
	const totalData = state.lokasi.count;

	const {
		resetPagination,
		setNewData,
		pagination,
		onPrevious,
		onNext,
		handleClickPageNumber,
		handleChangeLimit,
		loading,
		handleChange,
		formFilter,
		setFormFilter,
	} = useReloadTableLokasi();

	useEffect(() => {
		setNewData();
	}, []);

	const handleBackLokasi = async () => {
		if (children.length === 1) {
			setChildren([]);
			setNewData(1, 10, { parent_id_location: "", id_location: "", name: "" });

			setInfoChildren("");
		} else {
			const id = children[children.length - 1].id_location;
			const filterID = children.filter((x) => x.id_location !== id);
			await setNewData(1, 10, {
				parent_id_location: filterID[filterID.length - 1].id_location,
				name: "",
			});
			setChildren(filterID);

			const forPosisi = infoChildren.split("/");
			const filterPosisi = forPosisi[forPosisi.length - 1];
			const lastPosition = forPosisi.filter((x) => x !== filterPosisi);
			setInfoChildren(lastPosition.join("/"));
		}
	};

	const handleChildren = async (row) => {
		await setNewData(1, 10, {
			parent_id_location: row.id_location,
			name: "",
		});

		setChildren([
			...children,
			isNull(row.parent_id_location)
				? {
						id_location: row.id_location,
						id: row.id,
						parent_id_location: "",
				  }
				: {
						id_location: row.id_location,
						id: row.id,
						parent_id_location: row.parent_id_location,
				  },
		]);

		if (isNull(row.parent_id_location)) {
			setInfoChildren(row.kode);
		} else {
			setInfoChildren(`${infoChildren}/${row.kode}`);
		}
	};

	const handleCloseModal = async (row) => {
		setLokasi({
			id_location: row.id_location,
			nama: row.name,
		});
		setShowModal(false);
	};

	const handleSearch = async (row) => {
		setNewData(1, 10, {
			name: row,
			parent_id_location: "",
		});
	};

	return (
		<Modal title="Pilih Lokasi" show={setShowModal} width="75%">
			<Paper className={classes.paper}>
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						marginBottom: "10px",
					}}
				>
					<p className="fw-200 fs-16">
						Posisi Lokasi : {isNull(infoChildren) ? "-" : infoChildren}
					</p>
					<div
						style={{
							display: "flex",
							gap: "10px",
						}}
					>
						<SearchInput
							withIcon={true}
							onchange={(e) => handleSearch(e.target.value)}
						/>
						{children.length === 0 ? (
							<></>
						) : (
							<MasterButton
								type="submit"
								name={"Kembali"}
								size="md"
								color="warning"
								onClick={() => handleBackLokasi()}
							/>
						)}
					</div>
				</div>
				<OrganisasiLokasiTable
					rows={rows}
					resetPagination={resetPagination}
					handleChildren={handleChildren}
					totalData={totalData}
					handleCloseModal={handleCloseModal}
					setNewData={setNewData}
					pagination={pagination}
					onPrevious={onPrevious}
					onNext={onNext}
					handleClickPageNumber={handleClickPageNumber}
					handleChangeLimit={handleChangeLimit}
					loading={loading}
					handleChange={handleChange}
					formFilter={formFilter}
					setFormFilter={setFormFilter}
				/>
			</Paper>
		</Modal>
	);
};

export default OrganisasiLokasiPreview;
